import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import Vconsole from "vconsole";
// let vConsole = new Vconsole();

// createApp(App).use(vConsole);
createApp(App).use(store).use(router).mount("#app");
